module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  locals.trackingDetails.forEach(function(trackingDetail) { 
    ; __append(" ")
    ;  var dt = trackingDetail.get('datetime'); 
    ; __append(" <p> <strong>")
    ; __append(escapeFn( dt.format('YYYY-MM-DD')))
    ; __append("</strong> <small class=\"text-muted bold\">")
    ; __append(escapeFn( dt.format('HH:mm') ))
    ; __append("</small> <br> ")
    ; __append(escapeFn( trackingDetail.get('message') ))
    ; __append(" </p> ")
    ;  }); 
    ; __append(" ")
    ;  if (locals.trackingDetails.length === 0) { 
    ; __append(" <small class=\"text-muted\">(None)</small> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/trackers/tracking_details.ejs
// module id = 1841
// module chunks = 1